// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "header__cell-4kpIr";
var _3 = "fareGroup__name-1wcUA";
var _4 = "header__icon-3lFDX";
var _5 = "travelTime-32QdP";
var _6 = "arrowIcon-3BXtT";
export { _1 as "__esModule", _2 as "header__cell", _3 as "fareGroup__name", _4 as "header__icon", _5 as "travelTime", _6 as "arrowIcon" }
export default { "__esModule": _1, "header__cell": _2, "fareGroup__name": _3, "header__icon": _4, "travelTime": _5, "arrowIcon": _6 }
